import classNames from 'classnames';
import { HTMLAttributes, ReactNode, useState } from 'react';
import { PiImageBold, PiVideoBold } from 'react-icons/pi';
import { IChildrenProp } from 'types/components/components.interface';
import RadialAudioPlayer from '../audio-player/RadialAudioPlayer';
import './Card.scss';

export type TCardView = 'grid' | 'list';

interface ICardProps extends HTMLAttributes<HTMLDivElement>, IChildrenProp {
  image?: string;
  audio?: string;
  playerId?: string;
  header?: ReactNode;
  description?: ReactNode;
  supplementary?: ReactNode;
  status?: ReactNode;
  adjustImageWidth?: boolean;
  view?: TCardView;
  isVideo?: boolean;
}

const Card = ({
  header,
  description,
  supplementary,
  status,
  image,
  audio,
  playerId,
  adjustImageWidth,
  isVideo,
  view = 'list',
  ...props
}: ICardProps) => {
  const [imageError, setImageError] = useState(false);

  const className = classNames('card', `card--${view}`, props.className, {
    clickable: props.onClick !== undefined,
    adjustImageWidth,
  });

  return (
    <div {...props} className={className}>
      {image !== undefined &&
        (!imageError && image.length && view === 'list' ? (
          <img src={image} onError={() => setImageError(true)} alt="" />
        ) : !imageError && image.length && view === 'grid' ? (
          <div className="img-card-cover">
            <img src={image} onError={() => setImageError(true)} alt="" />
          </div>
        ) : (
          <div className="image-placeholder">
            <PiImageBold />
          </div>
        ))}

      {audio !== undefined && playerId && (
        <div className={view === 'list' ? '' : 'audio-player-grid-view'}>
          <RadialAudioPlayer playerId={playerId} audioSrc={audio} />
        </div>
      )}

      {isVideo && view === 'grid' && (
        <div className="image-placeholder">
          <PiVideoBold />
        </div>
      )}

      {(header || description || supplementary) && (
        <div className="card-name">
          {header && <div className="card-header">{header}</div>}
          {description && <div className="card-description">{description}</div>}
          {supplementary && <div className="card-supplementary">{supplementary}</div>}
        </div>
      )}

      {status && <div className="card-status">{status}</div>}
    </div>
  );
};

export default Card;
